/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIPlanningEnum } from './APIPlanningEnum';
import {
    APIPlanningEnumFromJSON,
    APIPlanningEnumFromJSONTyped,
    APIPlanningEnumToJSON,
} from './APIPlanningEnum';

/**
 * Mixin to provide model-field level permissions on the serializer level.
 * 
 * How to use:
 *     1. Add the mixin as the first inherited class to your serializer (at
 *        least before the SerializerExtensionsMixin).
 *     2. Make sure that Meta.model is specified on your serializer.
 *     3. Define a 'get_forbidden_fields' classmethod on the according model
 *        class that returns a list of fieldnames for all fields that a user
 *        is *not* allowed to view/edit. Example:
 * 
 *             @classmethod
 *             def get_forbidden_fields(cls, action: Literal["view", "create", "edit"],
 *                                      user) -> List[str]:
 *                 if action == "view":
 *                     if user.is_staff: return []
 * 
 *                     # for all other users
 *                     return [
 *                         "forbidden_field_name_1",
 *                         "forbidden_field_name_2,
 *                     ]
 *                 if action == "create":
 *                     pass
 *                 if action == "edit":
 *                     pass
 *                 return []
 * 
 * 
 * How to use with expandable fields:
 *     1. Setup the HyperlinkedRelatedField as usual.
 *     2. Add the field that relies on you permission-enriched serializer to
 *        the 'expandable_fields' dict and point it to 'SerializerMethodField'.
 *        (from rest_framework.serializers import SerializerMethodField)
 *     3. Add a serializer method with the name 'get_<expandable_field_name>'
 *        to the serializer that holds the expandable field.
 * 
 *     Example:
 * 
 *             class SerializerB( FieldLevelPermissionSerializerMixin,
 *                                SerializerExtensionMixin,
 *                                HyperlinkedModelSerializer):
 *                 class Meta:
 *                     model=B
 * 
 *             class SerializerA(SerializerExtensionMixin, HyperlinkedModelSerializer):
 *                 field_b = HyperlinkedRelatedField(
 *                     view_name="View-B-detail",
 *                     ...
 *                 )
 * 
 *                 get_field_b(self, obj):
 *                     "   Helper method that provides the nested serializer
 *                         SerializerB with the required information for
 *                         the FieldLevelPermissionSerializerMixin to work.
 *                        "
 *                     return SerializerB(context={
 *                         "request": self.context["request"],
 *                         "view": self.context["view"],
 *                         "expand": [
 *                             # prepare the argument for the next serializer
 *                             expand_arg.removeprefix("field_b__")
 *                             for expand_arg
 *                             in self.context["expand"]
 *                             # remove any arguments that are meant for the current serializer
 *                             if expand_arg.startswith("field_b__")
 *                         ],
 *                     }).to_representation(obj.field_b)
 * 
 *                 class Meta:
 *                     model=A
 *                     expandable_fields=dict(
 *                         field_a=SerializerMethodField
 *                     )
 * @export
 * @interface APIRequest
 */
export interface APIRequest {
    /**
     * 
     * @type {string}
     * @memberof APIRequest
     */
    readonly self: string;
    /**
     * 
     * @type {string}
     * @memberof APIRequest
     */
    readonly rootAccountName: string;
    /**
     * 
     * @type {string}
     * @memberof APIRequest
     */
    readonly article: string;
    /**
     * 
     * @type {Array<object>}
     * @memberof APIRequest
     */
    readonly requestArticles: Array<object>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIRequest
     */
    editors?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof APIRequest
     */
    contact?: string;
    /**
     * 
     * @type {string}
     * @memberof APIRequest
     */
    readonly files: string;
    /**
     * 
     * @type {boolean}
     * @memberof APIRequest
     */
    readonly read: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIRequest
     */
    isTemp?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof APIRequest
     */
    readonly quantities: Array<number>;
    /**
     * Calculated costs listed together with quantities as JSON object like {'100': '100', '200': '200', ...}
     * @type {{ [key: string]: any; }}
     * @memberof APIRequest
     */
    calculatedCosts?: { [key: string]: any; };
    /**
     * Detailed calculated costs per quantity written down as JSON object like {'100': {'estimated_price': '€ 10.00', 'estimated_material_cost': '€ 2.00', ...}, ...}
     * @type {{ [key: string]: any; }}
     * @memberof APIRequest
     */
    calculatedCostBreakdown?: { [key: string]: any; };
    /**
     * The costs per quantity reported by suppliers written down as JSON object like {'supplier_1': {quantity_1: price_1, quantity_2: price_2, ...}, ...}
     * @type {{ [key: string]: any; }}
     * @memberof APIRequest
     */
    reportedCosts?: { [key: string]: any; };
    /**
     * Optional price suggestion provided by the customer.
     * @type {string}
     * @memberof APIRequest
     */
    customerPriceSuggestion?: string;
    /**
     * 
     * @type {Date}
     * @memberof APIRequest
     */
    wishDate?: Date | null;
    /**
     * 
     * @type {APIPlanningEnum}
     * @memberof APIRequest
     */
    status: APIPlanningEnum;
    /**
     * 
     * @type {boolean}
     * @memberof APIRequest
     */
    priority?: boolean;
    /**
     * 
     * @type {string}
     * @memberof APIRequest
     */
    remarks?: string;
    /**
     * 
     * @type {string}
     * @memberof APIRequest
     */
    certificate?: string;
    /**
     * 
     * @type {string}
     * @memberof APIRequest
     */
    description?: string;
    /**
     * 
     * @type {Date}
     * @memberof APIRequest
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof APIRequest
     */
    readonly lastModifiedAt: Date;
    /**
     * Contact person for this Request.
     * @type {number}
     * @memberof APIRequest
     */
    readonly contactId: number | null;
}



/**
 * Check if a given object implements the APIRequest interface.
 */
export function instanceOfAPIRequest(value: object): value is APIRequest {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('rootAccountName' in value) || value['rootAccountName'] === undefined) return false;
    if (!('article' in value) || value['article'] === undefined) return false;
    if (!('requestArticles' in value) || value['requestArticles'] === undefined) return false;
    if (!('files' in value) || value['files'] === undefined) return false;
    if (!('read' in value) || value['read'] === undefined) return false;
    if (!('quantities' in value) || value['quantities'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('lastModifiedAt' in value) || value['lastModifiedAt'] === undefined) return false;
    if (!('contactId' in value) || value['contactId'] === undefined) return false;
    return true;
}

export function APIRequestFromJSON(json: any): APIRequest {
    return APIRequestFromJSONTyped(json, false);
}

export function APIRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'rootAccountName': json['root_account_name'],
        'article': json['article'],
        'requestArticles': json['request_articles'],
        'editors': json['editors'] == null ? undefined : json['editors'],
        'contact': json['contact'] == null ? undefined : json['contact'],
        'files': json['files'],
        'read': json['read'],
        'isTemp': json['is_temp'] == null ? undefined : json['is_temp'],
        'quantities': json['quantities'],
        'calculatedCosts': json['calculated_costs'] == null ? undefined : json['calculated_costs'],
        'calculatedCostBreakdown': json['calculated_cost_breakdown'] == null ? undefined : json['calculated_cost_breakdown'],
        'reportedCosts': json['reported_costs'] == null ? undefined : json['reported_costs'],
        'customerPriceSuggestion': json['customer_price_suggestion'] == null ? undefined : json['customer_price_suggestion'],
        'wishDate': json['wish_date'] == null ? undefined : (new Date(json['wish_date'])),
        'status': APIPlanningEnumFromJSON(json['status']),
        'priority': json['priority'] == null ? undefined : json['priority'],
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
        'certificate': json['certificate'] == null ? undefined : json['certificate'],
        'description': json['description'] == null ? undefined : json['description'],
        'createdAt': (new Date(json['created_at'])),
        'lastModifiedAt': (new Date(json['last_modified_at'])),
        'contactId': json['contact_id'],
    };
}

export function APIRequestToJSON(value?: Omit<APIRequest, 'self'|'root_account_name'|'article'|'request_articles'|'files'|'read'|'quantities'|'created_at'|'last_modified_at'|'contact_id'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'editors': value['editors'],
        'contact': value['contact'],
        'is_temp': value['isTemp'],
        'calculated_costs': value['calculatedCosts'],
        'calculated_cost_breakdown': value['calculatedCostBreakdown'],
        'reported_costs': value['reportedCosts'],
        'customer_price_suggestion': value['customerPriceSuggestion'],
        'wish_date': value['wishDate'] == null ? undefined : ((value['wishDate'] as any).toISOString().substring(0,10)),
        'status': APIPlanningEnumToJSON(value['status']),
        'priority': value['priority'],
        'remarks': value['remarks'],
        'certificate': value['certificate'],
        'description': value['description'],
    };
}

